import { SizeGrid } from '@trwl/widgets/product/sizeGrid/SizeGrid';
import React from 'react';

import {
  NB_WIDTH_TABLE_FEMALE,
  NB_WIDTH_TABLE_MALE,
} from './newBalanceWidthTable.constant';

export const NewBalanceSizeGrid = () => {
  return (
    <div className={'w-full'}>
      <SizeGrid
        sizeGrid={NB_WIDTH_TABLE_MALE}
        title={'Ширина обуви у мужчин'}
      />
      <SizeGrid
        className={'mt-[35px]'}
        sizeGrid={NB_WIDTH_TABLE_FEMALE}
        title={'Ширина обуви у женщин'}
      />
    </div>
  );
};
